import React, { Component } from "react";
import TableCell from "@material-ui/core/TableCell";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import { Checkbox } from "@material-ui/core";
import {
  ColumnTypes,
  SortTypes,
  ColumnStickyTypes,
  JustificationTypes,
} from "../util/table-view/TableTypes";
import { Translation } from "react-i18next";
import TableColFilter from "./TableColFilter";
import {
  getAriaLabelForSelectCheckBoxAll,
  getAriaLabelForColumnThumb,
  getAriaLabelForColumnMenu,
  getAriaLabelForColumnPlay,
} from "./Accessibility";
import DiscreteFlag from "./DiscreteFlag";
import { columnFieldConfig } from "modules/column-config/ColumnConfig";

class TableHeaderCol extends Component {
  cellContentRender(t) {
    const { classes, column, columns, noColFilters, row } = this.props;
    // let column = baseColumn.extentedProps? columnFieldConfig(baseColumn,row) : baseColumn ;
    switch (column.type) {
      case ColumnTypes.player:
      case ColumnTypes.playerAndThumb:
      case ColumnTypes.downloader:
        if (column.tablePageType) {
          return (
            <span
              className={classes.appbarHideLabel}
              aria-label={getAriaLabelForColumnPlay(column.tablePageType)}
            >
              {/* {getAriaLabelForColumnPlay(column.tablePageType)} */}
            </span>
          );
        } else {
          return null;
        }
      case ColumnTypes.thumb:
        if (column.tablePageType) {
          return (
            <span
              className={classes.appbarHideLabel}
              aria-label={getAriaLabelForColumnThumb(column.tablePageType)}
            >
              {getAriaLabelForColumnThumb(column.tablePageType)}
            </span>
          );
        } else {
          return null;
        }
      case ColumnTypes.menu:
        if (column.tablePageType) {
          return (
            <span
              className={classes.appbarHideLabel}
              aria-label={getAriaLabelForColumnMenu(column.tablePageType)}
            >
              {getAriaLabelForColumnMenu(column.tablePageType)}
            </span>
          );
        } else {
          return null;
        }

      case ColumnTypes.score:
        return <span aria-label={"Score"}>SCORE</span>;
      case ColumnTypes.exapandArrow:
        return <span aria-label={"Expand"}></span>;

      case ColumnTypes.selector:
        const isAllSelected = () => {
          const {
            idField,
            data: { items, selectedItems, skipSelectAllList },
          } = this.props;

          const filteredItems = items?.filter(item => !skipSelectAllList?.includes(item[idField])) || [];
          const rItems = filteredItems.length > 0 && selectedItems.length === filteredItems.length;

          return rItems;
        };

        const isSelectIndeterminate = () => {
          const {
            data: { items, selectedItems },
          } = this.props;
          return (
            selectedItems?.length > 0 &&
            items?.length > 0 &&
            selectedItems?.length < items?.length
          );
        };

        const handleSelectAllClick = (event) => {
          if (event.target.checked) {
            const {
              idField,
              data: { items, skipSelectAllList },
              selectItems,
            } = this.props;

            const newSelecteds = items
              ?.filter(item => !skipSelectAllList?.includes(item[idField]))
              ?.map(item => item[idField]);

            selectItems(newSelecteds);

          } else {
            const { selectItems } = this.props;
            selectItems([]);
          }
        };
        return (
          <>
            <span className={classes.appbarHideLabel}>Select all</span>
            <Checkbox
              indeterminate={isSelectIndeterminate()}
              checked={isAllSelected()}
              onChange={handleSelectAllClick}
              aria-label={
                column.tablePageType
                  ? getAriaLabelForSelectCheckBoxAll(column.tablePageType)
                  : null
              }
              inputProps={{
                "aria-label": `${column.tablePageType
                  ? getAriaLabelForSelectCheckBoxAll(column.tablePageType)
                  : null
                  }`,
              }}
            />
          </>
        );
      case ColumnTypes.content_admin_selector:
        const isAllContentSelected = () => {
          const {
            data: { items, selectedItems },
          } = this.props;
          return items?.length > 0 && selectedItems.length === items.length;
        };

        const isSelectContentIndeterminate = () => {
          const {
            data: { items, selectedItems },
          } = this.props;
          return (
            selectedItems.length > 0 &&
            items.length > 0 &&
            selectedItems.length < items.length
          );
        };

        const handleContentSelectAllClick = (event) => {
          if (event.target.checked) {
            const {
              idField,
              data: { items },
              selectItems,
            } = this.props;
            const newSelecteds = items.map((item) => item[idField]);
            selectItems(newSelecteds);
          } else {
            const { selectItems } = this.props;
            selectItems([]);
          }
        };
        return (
          <>
            <span className={classes.appbarHideLabel}>Select all</span>
            <Checkbox
              indeterminate={isSelectContentIndeterminate()}
              checked={isAllContentSelected()}
              onChange={handleContentSelectAllClick}
              aria-label={
                column.tablePageType
                  ? getAriaLabelForSelectCheckBoxAll(column.tablePageType)
                  : "Select All"
              }
              inputProps={{
                "aria-label": `${column.tablePageType
                  ? getAriaLabelForSelectCheckBoxAll(column.tablePageType)
                  : "Select All"
                  }`,
              }}
            />
          </>
        );
      case ColumnTypes.cuesheet_link_tracks_selector:
        let validTrackIdsLength = 0;
        const {
          data: {  timeCodeSorting },
        } = this.props;
        const isAllSelectedCueSheet = () => {        
          const {
            data: { items, selectedItems, cueSheet: { cueData }, timeCodeSorting },
          } = this.props;

          let validTrackIds = cueData?.clearance_tracks
              .filter(track =>
                track.clearance_track_usages.some(
                  usage =>
                    usage.duration !== "" &&
                    usage.duration !== "00:00:00" &&
                    usage.duration !== "00:00:" &&
                    !usage.duration.includes("NaN") &&
                    !usage.added &&
                    (usage["validTc"] == undefined || usage["validTc"] == true)
                ) && track.clearance_track_usages.filter(i => i["validTc"] == false).length == 0
              )
              .map(trackF => trackF.clearance_track_id);
          return validTrackIds?.length > 0 && selectedItems.length === validTrackIds.length;
        };
       
        const handleCusSheetLinkTracksSelectClickAll = (event) => {
          const {
            data: { selectedItems, items, cueSheet: { cueData }, timeCodeSorting },
            selectItems,
          } = this.props;
          if (event.target.checked) {
            let validTrackIds = cueData.clearance_tracks
              .filter(track =>
                track.clearance_track_usages.some(
                  usage =>
                    usage.duration !== "" &&
                    usage.duration !== "00:00:00" &&
                    usage.duration !== "00:00:" &&
                    !usage.duration.includes("NaN") && 
                    !usage.added &&
                    (usage["validTc"] == undefined || usage["validTc"] == true)
                ) && track.clearance_track_usages.filter(i => i["validTc"] == false).length == 0
              )
              .map(trackF => trackF.clearance_track_id);

            let matchingItemIds = items
              .filter(item =>
                validTrackIds.includes(item.trackDetails.id) // Check if track ID is in validTrackIds
              )
              .map(item =>  timeCodeSorting? item.usageUniqueId : item.id); // Extract the matching item ID

            selectItems(matchingItemIds);
            validTrackIdsLength = validTrackIds.length;
          }
          else {
            const { selectItems } = this.props;
            selectItems([]);
          }

          
        };
        if (timeCodeSorting) {
          return null; // Don't render checkbox ,
        }
        return (
          <Checkbox
            checked={isAllSelectedCueSheet(validTrackIdsLength)}
            onChange={handleCusSheetLinkTracksSelectClickAll}
            onClick={(e) => e.stopPropagation()}
            aria-label={
              column.tablePageType
                ? getAriaLabelForSelectCheckBoxAll(column.tablePageType)
                : null
            }
            // disabled={column.isDisable && column.isDisable(row) ? true : false}
            inputProps={{
              "aria-label": `${column.tablePageType
                ? getAriaLabelForSelectCheckBoxAll(column.tablePageType)
                : null
                }`,
            }}
          />
        );
      default:
        const {
          data: {
            query: { order, orderBy },
          },
        } = this.props;
        const sortHandler = (field) => {
          const {
            setQuery,
            search,
            data: {
              query,
              query: { order, orderBy },
            },
          } = this.props;
          const newOrder =
          (orderBy !== field && column.defaultSort) 
          ? column.defaultSort 
          : (orderBy === field && order === SortTypes.asc)
              ? SortTypes.desc
              : SortTypes.asc;
          let newQuery = { ...query, order: newOrder, orderBy: field, page: 0 };
          setQuery(newQuery, () => {
            search(newQuery, this.props.isSandbox);
          });
        };
        const { accessHeaderProps } = column.cellProp ? column.cellProp(row, this.props) : {};

        return (
          <>
            {column.isSortable ? (
              <TableSortLabel
                aria-label={
                  orderBy === column.field
                    ? `Order results by ${accessHeaderProps && accessHeaderProps.ariaLabel ? accessHeaderProps.ariaLabel : column.label} ${order === SortTypes.desc ? "descending" : "ascending"
                    }`
                    : `${accessHeaderProps && accessHeaderProps.ariaLabel ? accessHeaderProps.ariaLabel : column.label} unordered`
                }
                active={orderBy === column.field}
                direction={orderBy === column.field ? order : SortTypes.asc}
                onClick={() => {
                  sortHandler(column.field);
                }}
              >
                {column.headerRenderer ?? <label className={classes.tableLabel}>{column.label}</label>}
                {orderBy === column.field ? (
                  <span className={classes.tableVisuallyHidden}>
                    {order === SortTypes.desc
                      ? "sorted descending"
                      : "sorted ascending"}
                  </span>
                ) : null}
              </TableSortLabel>
            ) : column.isMultiLabel && column.optionalLabels.length > 0 ?

              <>
                <label>{column.label}</label>
                {column.optionalLabels.length > 0 && column.optionalLabels.map((item, index) => {
                  return (
                    <label key={index} className={item.class}>{item.label}</label>
                  )
                })}
              </>
              : column.headerRenderer ?? column.label !== "" ? (
                <label>{column.label}</label>
              ) : (
                <span className={classes.appbarHideLabel}>Empty</span>
              )}
            {/* {!this.props.isSandbox && column.discretable && this.props?.groupResults ? <DiscreteFlag {...this.props}/> : null } */}
            {!noColFilters && column.isFilterable ? (
              <TableColFilter columns={columns} {...this.props} />
            ) : null}
          </>
        );
    }
  }

  render() {
    const {
      classes,
      column,
      data: {
        query: { order, orderBy },
      },
    } = this.props;
    return (
      <Translation>
        {(t, { i18n }) => {
          const cellProps = {
            align: column.alignHeader || JustificationTypes.left,
            key: column.field,
            width: column.width,
            sortDirection: orderBy === column.field ? order : false,
            ...(column.isFilterable && {
              className: classes.tabelCellstyle,
            }),
            ...(column.sticky === ColumnStickyTypes.right && {
              style: {
                position: "sticky",
                right: 0,
                top: 0,
                // background: "#303030",
                zIndex: 3,
              },
            }),
            ...(column.sticky === ColumnStickyTypes.left && {
              style: {
                position: "sticky",
                left: 0,
                top: 0,
                //  background: "#303030",
                zIndex: 3,
              },
            }),
            title: column.altTitle ?? ""
          };
          return (
            <TableCell {...cellProps}>{this.cellContentRender(t)}</TableCell>
          );
        }}
      </Translation>
    );
  }
}

export default TableHeaderCol;
